export default {"src":"/_next/static/media/image_logo_icon.d1a48642.svg","height":30,"width":29,"blurWidth":0,"blurHeight":0};